import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../../data/landing';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-5 py-16 md:py-24" data-id="element-137" data-mp="122vf0mmg35sn">
      <div className="mx-auto max-w-3xl" data-id="element-138" data-mp="1prxupoxiqoki">
        <SectionHeading title="Frequently asked questions" data-id="element-139" data-mp="1pszechslojdu" />
        <ul className="mt-10 divide-y divide-navy/10 border-y border-navy/10" data-id="element-140" data-mp="1uq92zv860r0m">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} data-id="element-141" data-mp="1l17lu1pvw3l2" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-sky" data-id="element-142" data-mp="1l0fux478eu14">
                  <span className="text-[17px] font-bold text-navy" data-id="element-143" data-mp="2oo4ivptn4m41">{f.q}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-sky transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-144" data-mp="2jsp6717dcw97" />
                </button>
                <AnimatePresence initial={false} data-id="element-145" data-mp="37gq8hsdyfgg6">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-146" data-mp="37ijhhec1icrc">
                      <p className="pb-5 text-[16px] leading-relaxed text-muted" data-id="element-147" data-mp="1n1ocg9ghnuv6">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <div className="mt-12" data-id="element-148" data-mp="27s0nqjgvwrbb">
          <CtaButton label="I’m ready to map my next case" data-id="element-149" data-mp="2br9i9qjr0t7x" />
        </div>
      </div>
    </section>;
}